module.exports = __webpack_public_path__ + "img/profpic1.6ce60eb3.jpg";